export const FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_STORE_KEY =
  'ORGANIZATION_INTERNAL_OWNERS/FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID';
export const FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_REQUESTED =
  'ORGANIZATION_INTERNAL_OWNERS/FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_REQUESTED';
export const FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_SUCCESS =
  'ORGANIZATION_INTERNAL_OWNERS/FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_SUCCESS';
export const FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_FAILED =
  'ORGANIZATION_INTERNAL_OWNERS/FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_FAILED';

export function fetchOrganizationInternalOwnersByIdRequested(organizationId: string) {
  return {
    type: FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_REQUESTED,
    payload: {
      organizationId,
    },
  } as const;
}

export function fetchOrganizationInternalOwnersByIdSuccess(ids: string[]) {
  return {
    type: FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_SUCCESS,
    payload: {
      ids,
    },
  } as const;
}

export function fetchOrganizationInternalOwnersByIdFailed(error: string) {
  return {
    type: FETCH_ORGANIZATION_INTERNAL_OWNERS_BY_ID_API_FAILED,
    payload: error,
  } as const;
}

export const ASSIGN_ACCOUNT_MANAGER_STORE_KEY = 'ORGANIZATION_INTERNAL_OWNERS/ASSIGN_ACCOUNT_MANAGER';
export const ASSIGN_ACCOUNT_MANAGER_API_REQUESTED = 'ORGANIZATION_INTERNAL_OWNERS/ASSIGN_ACCOUNT_MANAGER_API_REQUESTED';
export const ASSIGN_ACCOUNT_MANAGER_API_SUCCESS = 'ORGANIZATION_INTERNAL_OWNERS/ASSIGN_ACCOUNT_MANAGER_API_SUCCESS';
export const ASSIGN_ACCOUNT_MANAGER_API_FAILED = 'ORGANIZATION_INTERNAL_OWNERS/ASSIGN_ACCOUNT_MANAGER_API_FAILED';

export function assignAccountManagerRequested(organizationId: string, internalTeamMemberId: string) {
  return {
    type: ASSIGN_ACCOUNT_MANAGER_API_REQUESTED,
    payload: {
      organizationId,
      internalTeamMemberId,
    },
  } as const;
}

export function assignAccountManagerSuccess() {
  return {
    type: ASSIGN_ACCOUNT_MANAGER_API_SUCCESS,
  } as const;
}

export function assignAccountManagerFailed(error: string) {
  return {
    type: ASSIGN_ACCOUNT_MANAGER_API_FAILED,
    payload: error,
  } as const;
}

export const UNASSIGN_ACCOUNT_MANAGER_STORE_KEY = 'ORGANIZATION_INTERNAL_OWNERS/UNASSIGN_ACCOUNT_MANAGER';
export const UNASSIGN_ACCOUNT_MANAGER_API_REQUESTED = 'ORGANIZATION_INTERNAL_OWNERS/UNASSIGN_ACCOUNT_MANAGER_API_REQUESTED';
export const UNASSIGN_ACCOUNT_MANAGER_API_SUCCESS = 'ORGANIZATION_INTERNAL_OWNERS/UNASSIGN_ACCOUNT_MANAGER_API_SUCCESS';
export const UNASSIGN_ACCOUNT_MANAGER_API_FAILED = 'ORGANIZATION_INTERNAL_OWNERS/UNASSIGN_ACCOUNT_MANAGER_API_FAILED';

export function unassignAccountManagerRequested(organizationId: string) {
  return {
    type: UNASSIGN_ACCOUNT_MANAGER_API_REQUESTED,
    payload: {
      organizationId,
    },
  } as const;
}

export function unassignAccountManagerSuccess() {
  return {
    type: UNASSIGN_ACCOUNT_MANAGER_API_SUCCESS,
  } as const;
}

export function unassignAccountManagerFailed(error: string) {
  return {
    type: UNASSIGN_ACCOUNT_MANAGER_API_FAILED,
    payload: error,
  } as const;
}

export type OrganizationInternalOwnerActions = ReturnType<
  | typeof fetchOrganizationInternalOwnersByIdRequested
  | typeof fetchOrganizationInternalOwnersByIdSuccess
  | typeof fetchOrganizationInternalOwnersByIdFailed
  | typeof assignAccountManagerRequested
  | typeof assignAccountManagerSuccess
  | typeof assignAccountManagerFailed
  | typeof unassignAccountManagerRequested
  | typeof unassignAccountManagerSuccess
  | typeof unassignAccountManagerFailed
>;
